import React from "react";
import NotificationPanel from "../components/MyNoti/NotificationPanel";

const MyNotification: React.FC = () => {
  return <NotificationPanel />;
};

export default MyNotification;
